import React from 'react';
import { useLocation } from 'react-router-dom';

import { SiteConfigManager } from '@atlas/core';
import { staticRoutes } from '@atlas/routing';

import FooterSocial from './FooterSocial/FooterSocial';
import Copyright from './Copyright';
import FooterLanguageSwitcher from './FooterLanguageSwitcher';
import FooterMobileApplicationLink from './FooterMobileApplicationLink';
import MenuFooterPaymentsList from './MenuFooterPaymentsList';

const disableRenders = [staticRoutes.luckyday, staticRoutes.signin, staticRoutes.signup];
const allwaysRenders = [staticRoutes.menu];

const Footer = () => {
  const { pathname } = useLocation();
  const enableFooterForAllPages = SiteConfigManager.getConfig(
    'config.config.general.enableFooterForAllPages',
  );

  if (
    (!enableFooterForAllPages && !allwaysRenders.includes(pathname)) ||
    disableRenders.includes(pathname)
  )
    return null;

  return (
    <div className="menu-footer-container">
      <FooterSocial />
      <FooterLanguageSwitcher />
      <MenuFooterPaymentsList />
      <FooterMobileApplicationLink />
      <Copyright />
    </div>
  );
};
export default Footer;
